<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader />
		<fuHeader />
		<crumbs :txt="a" type="2" :ljList="ljList" @hdBtn="hdBtn" :crumFlag="crumFlag" height="53px" />
		<div class="meiWecBox">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="hdBtn">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
				<template v-if="type != 1">
					<div class="gudBtnItem supHove3" @click="scFn(hbData)" :class="hbData.isCollect ? 'activeBtn' : ''">
						<img src="@/assets/img/sc (4).svg" v-show="!hbData.isCollect" alt="" />
						<img src="@/assets/img/sc (2).svg" v-show="hbData.isCollect" alt="" />
						<span>{{ hbData.isCollect ? '已收藏' : '收藏' }}</span>
					</div>
					<div class="gudBtnItem supHove3" @click="xzBtn">
						<img src="@/assets/img/形状备份.png" alt="" />
						<span>下载</span>
					</div>
					<div class="gudBtnItem gudBtnItem1">
						<img src="@/assets/img/fenx (1).svg" class="img1" alt="" />
						<img src="@/assets/img/fenx.svg" class="img2" alt="" />
						<span>分享</span>
						<div class="erwB">
							<img :src="qrCodeImage" alt="" />
							<p>微信扫码分享</p>
						</div>
					</div>
				</template>
			</div>
			<div class="meiWecL meiWecL5" ref="meiWecL5">
				<div class="meiWecL5-content">
					<div class="meiWecL5T">
						<span>日期： {{ (hbData.releaseTime || hbData.createTime) | momentYR('YYYY年MM月DD日') }}</span>
						<!-- <span>编写人：{{hbData.createNickName}}</span> -->
					</div>
					<div class="meiWecL5P" v-if="yzType" v-html="hbData.content"></div>
					<div class="meiWecL5P" v-if="!yzType" v-html="hbData.intro"></div>
					<!-- <div class="meiWecL5B meiWecL5B1" v-show="fzFlag">
				  预览内容 <br />
				  附件文件类型在线插件
			  </div> -->
					<!-- <div class="meiWecL5B" v-show="!fzFlag">
						<iframe ref="frame" v-if="ifsFlag" :src="onlineUrl" style="width: 100%; border: 0" :style="{ height: iframeHeight ? iframeHeight + 'px' : '800px' }" />
						<iframe ref="frame" v-if="ifsFlag" :src="qrSrc" style="width: 100%; border: 0" :style="{ height: iframeHeight ? iframeHeight + 'px' : '800px' }" />
					</div> -->
					<div class="previewBox">
						<div class="files-num" @click="openPreviewDialog">
							<img class="file" src="@/assets/img/file.svg" alt="" />
							<span class="label">共{{ filesNum || 0 }}份附件</span>
							<img class="arrow" src="@/assets/img/jr (3).svg" alt="" />
						</div>
						<div class="previewUrls" v-if="previewOutFile.previewUrl">
							<div class="preview-section" >
								<template v-if="previewTip">
									<div class="previewTip">{{ previewTip }}</div>
								</template>
								<template v-else-if="!previewOutFile.isPreview">
									<div class="no-data">文件无法预览</div>
								</template>
								<template v-else-if="previewOutFile.previewUrl == 'fail'">
									<div class="no-data">文件预览失败</div>
								</template>
								<template v-else-if="previewOutFile.attType == 'png'">
									<el-image class="img" :src="previewOutFile.previewUrl" :preview-src-list="[previewOutFile.previewUrl]"></el-image>
								</template>
								<template v-else-if="previewOutFile.attType == 'jpg'">
									<el-image class="img" :src="previewOutFile.previewUrl" :preview-src-list="[previewOutFile.previewUrl]"></el-image>
								</template>
								<template v-else-if="previewOutFile.attType == 'mp3'">
									<div class="ausBox">
										<myAudio types="2" v-if="previewOutFile.previewUrl" :audioUrl="previewOutFile.previewUrl" :title="previewOutFile.name" />
									</div>
								</template>
								<template v-else-if="previewOutFile.attType == 'mp4'">
									<div class="vidBox">
										<myVideo
											ref="reVideo"
											v-if="previewOutFile.previewUrl"
											:audioUrl="''"
											:audioResourceFileId="0"
											:coverImg="''"
											:subtitlingUrl="''"
											:videoUrl="previewOutFile.previewUrl"
											:videoResourceFileId="0"
											pyFlag="py"
										/>
									</div>
								</template>
								<template v-else>
									<iframe class="iframe" ref="frame" :src="previewOutFile.previewUrl" style="width: 100%; border: 0" :style="{ height: iframeHeight ? iframeHeight + 'px' : '800px' }" />
									<div class="doc-preview-expand-bar" v-if="previewOutFile.pagesPercentage != null && previewOutFile.pagesPercentage < 100">
										<button type="button" class="doc-preview-expand-btn" @click="onDownloadPreviewAll">
											<span class="doc-preview-expand-btn__status">剩余{{ 100 - previewOutFile.pagesPercentage }}%未加载，</span>
											<span class="doc-preview-expand-btn__action">下载后预览所有内容</span>
											<i class="doc-preview-expand-btn__arrow"></i>
										</button>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
				<div class="meiWecL5-copyright" v-if="hbData.showCopyrightFlag == 1">
					<div class="meiWecL5P" v-html="hbData.copyright"></div>
				</div>
			</div>
			<div class="meiWecR meiWecR5" v-if="type == 5">
				<div class="meiWecRBox">
					<div class="meiWecTit meiWecTit5">
						<span>附件预览</span>
					</div>
					<div class="meiWecFj">
						<p :title="hbData.title">{{ hbData.title }}</p>
						<div class="meiWecFjBot">
							<div class="meiWecFjXz meiWecFjXzX" v-if="!yzType">
								<img src="@/assets/img/jf.svg" alt="" />
								<span>{{ hbData.points || 0 }}</span>
							</div>
							<div class="meiWecFjVip infoMyPut" v-if="yzType && hbData.limitsAuthority == 0">
								<i class="el-icon-user-solid"></i>
								<span>普通老师</span>
							</div>
							<div class="meiWecFjVip" v-if="yzType && hbData.limitsAuthority == 1">
								<img src="@/assets/img/hys.svg" alt="" />
								<span>会员老师</span>
							</div>
							<div class="meiWecFjXz">
								<img src="@/assets/img/xiazai.svg" alt="" />
								下载量：{{ hbData.downloadNum || 0 }}
							</div>
						</div>
					</div>
					<div class="meiWecFjFot" :class="$lxfn(hbData.resourceFileName)">
						<div class="meiWecFjItem">
							<img :src="$imgFn('文本', 2)" alt="" />
							<p>文本</p>
						</div>
						<div class="meiWecFjItem">
							<img :src="$imgFn('视频', 2)" alt="" />
							<p>视频</p>
						</div>
						<div class="meiWecFjItem">
							<img :src="$imgFn('音频', 2)" alt="" />
							<p>音频</p>
						</div>
					</div>
				</div>
				<div class="meiWecRBox" v-if="classType != 99">
					<div class="meiWecTit meiWecTit5">
						<span>更多推荐</span>
					</div>
					<div class="meiWecRBoxC" v-if="!hbList.length">
						<el-empty description="暂无推荐"></el-empty>
					</div>
					<div class="meiWecRBoxC">
						<div class="meiWecRCItem supHove5" v-for="item in hbList" :key="item.mutualAidResourceId" @click="tabFn(item)">
							<div class="imgs">
								<el-image :src="$imgFn(item.resourceFileName, 1)" lazy></el-image>
							</div>
							<div class="meiWecRCItemR">
								<p :title="item.title">{{ item.title }}</p>
								<div class="meiWecRCItemRF">
									<div class="meiWecFjXz meiWecFjXzX" v-if="!yzType">
										<img src="@/assets/img/jf.svg" alt="" />
										<span>{{ item.points || 0 }}</span>
									</div>
									<div class="meiWecFjVip infoMyPut" v-if="yzType && item.limitsAuthority == 0">
										<i class="el-icon-user-solid"></i>
										<span>普通老师</span>
									</div>
									<div class="meiWecFjVip" v-if="yzType && item.limitsAuthority == 1">
										<img src="@/assets/img/hys.svg" alt="" />
										<span>会员老师</span>
									</div>
									<div class="meiWecFjXz">
										<img src="@/assets/img/xiazai.svg" alt="" />
										下载量：{{ item.downloadNum || 0 }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="meiWecR meiWecR5" v-if="type == 6">
				<div class="meiWecRBox">
					<div class="meiWecTit meiWecTit5">
						<span>更多推荐</span>
					</div>
					<div class="meiWecRBoxC" v-if="!hbList.length">
						<el-empty description="暂无推荐"></el-empty>
					</div>
					<div class="meiWecRBoxC" v-if="hbList.length">
						<div class="meiWecRCItem meiWecRCItem6 supHove5" v-for="item in hbList" :key="item.toolResourceId" @click="tabFn(item)">
							<img :src="$imgFn(item.resourceFileName, 1)" alt="" />
							<div class="meiWecRCItemR">
								<p :title="item.title">{{ item.title }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<foot />

		<el-dialog title="文档下载" :visible.sync="downloadDialogVisible" width="50%">
			<div class="download-dialog">
				<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
				<div style="margin: 15px 0"></div>

				<div class="files">
					<el-checkbox-group v-model="checkedFiles" @change="handleCheckedFilesChange">
						<div class="file" v-for="(item, index) in fileGroup" :key="item.attId">
							<el-checkbox :label="item.attId">{{ item.name }}</el-checkbox>
						</div>
					</el-checkbox-group>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeDownloadDialog">取 消</el-button>
				<el-button type="primary" @click="xzBtn">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="文档预览" :visible.sync="previewDialogVisible" width="1200px" top="10vh">
			<div class="preview-dialog">
				<div class="preview-section" v-loading="loading">
					<template v-if="previewTip">
						<div class="previewTip">{{ previewTip }}</div>
					</template>
					<template v-else-if="!previewFile.isPreview">
						<div class="no-data">文件无法预览</div>
					</template>
					<template v-else-if="previewFile.previewUrl == 'fail'">
						<div class="no-data">文件预览失败</div>
					</template>
					<template v-else-if="previewFile.attType == 'png'">
						<el-image class="img" :src="previewFile.previewUrl" :preview-src-list="[previewFile.previewUrl]"></el-image>
					</template>
					<template v-else-if="previewFile.attType == 'jpg'">
						<el-image class="img" :src="previewFile.previewUrl" :preview-src-list="[previewFile.previewUrl]"></el-image>
					</template>
					<template v-else-if="previewFile.attType == 'mp3'">
						<div class="ausBox">
							<myAudio types="2" v-if="previewFile.previewUrl" :audioUrl="previewFile.previewUrl" :title="previewFile.name" />
						</div>
					</template>
					<template v-else-if="previewFile.attType == 'mp4'">
						<div class="vidBox">
							<myVideo
								ref="reVideo"
								v-if="previewFile.previewUrl"
								:audioUrl="''"
								:audioResourceFileId="0"
								:coverImg="''"
								:subtitlingUrl="''"
								:videoUrl="previewFile.previewUrl"
								:videoResourceFileId="0"
								pyFlag="py"
							/>
						</div>
					</template>
					<template v-else>
						<iframe class="iframe" ref="frame" :src="previewFile.previewUrl" style="width: 100%; border: 0" />
						<div class="doc-preview-expand-bar" v-if="previewFile.pagesPercentage != null && previewFile.pagesPercentage < 100">
							<button type="button" class="doc-preview-expand-btn" @click="onDownloadPreviewAll">
								<span class="doc-preview-expand-btn__status">剩余{{ 100 - previewFile.pagesPercentage }}%未加载，</span>
								<span class="doc-preview-expand-btn__action">下载后预览所有内容</span>
								<i class="doc-preview-expand-btn__arrow"></i>
							</button>
						</div>
					</template>
				</div>
				<div class="right-section">
					<div class="group" v-for="(group, index) in fileGroup" :key="index">
						<div class="group-title" :class="{ isShow: group.show }" v-if="group.type == 2" @click="changeGroupShow(group)">
							<img class="arrow" src="@/assets/img/arrow.svg" alt="" />
							<span>{{ group.name }}</span>
						</div>
						<div
							v-show="group.show"
							class="file"
							:class="{ active: item.attId == attId, isLeaf: group.type == 2 }"
							v-for="(item, index) in group.group"
							:key="index"
							@click="changePreview(item, index)"
						>
							<div class="icon" style="width: 40px">
								<el-image :src="$imgFn(item.name, 1)"></el-image>
							</div>
							<div class="title">{{ item.name }}</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import crumbs from '@/components/hearder/crumbs';
import userHeader from '@/components/hearder/userHeader';
import myAudio from '@/components/pubComponents/myAudio';
import myVideo from '@/components/pubComponents/myVideo';
import fuHeader from '@/components/hearder/fuHeader';
import axios from 'axios';
import { batchDownloadNest, batchDownload } from '@/assets/js/xz';
import COS from 'cos-js-sdk-v5';

// SECRETID 和 SECRETKEY 请登录 https://console.cloud.tencent.com/cam/capi 进行查看和管理
const cos = new COS({
	SecretId: process.env.VUE_APP_SecretId, // 推荐使用环境变量获取；用户的 SecretId，建议使用子账号密钥，授权遵循最小权限指引，降低使用风险。子账号密钥获取可参考https://cloud.tencent.com/document/product/598/37140
	SecretKey: process.env.VUE_APP_SecretKey // 推荐使用环境变量获取；用户的 SecretKey，建议使用子账号密钥，授权遵循最小权限指引，降低使用风险。子账号密钥获取可参考https://cloud.tencent.com/document/product/598/37140
});

// 模拟远程文件URL - 在实际应用中替换为真实URL
const FILE_URLS = [
	{
		pid: 1,
		name: '文档转码_1.jpg',
		url: 'https://youyidian-1304869628.cos.ap-nanjing.myqcloud.com/文档转码_1.jpg'
	},
	{
		pid: 2,
		name: '文档转码_1.pdf',
		url: 'https://youyidian-1304869628.cos.ap-nanjing.myqcloud.com/文档转码_1.pdf'
	},
	{
		pid: 1,
		name: 'city.png',
		url: 'https://youyidian-1304869628.cos.ap-nanjing.myqcloud.com/city.png'
	},
	{
		pid: 2,
		name: '261756198243978-第341期听歌曲学英语《WaitingGame》.mp3',
		url: 'https://youyidian-1304869628.cos.ap-nanjing.myqcloud.com/261756198243978-第341期听歌曲学英语《WaitingGame》.mp3'
	},
	{
		pid: 3,
		name: '烟花.mp4',
		url: 'https://youyidian-1304869628.cos.ap-nanjing.myqcloud.com/烟花.mp4'
	}
];

export default {
	name: 'hbDec',
	data() {
		return {
			type: 5, // 5互帮互助 6常用工具
			yzType: '', // 是否优质
			hbList: [],
			txt: '',
			classType: '',
			a: ['个人中心'],
			documentResourceId: '',
			toolResourceId: '',
			mutualAidResourceId: '',
			flags: '',
			conTxt: '',
			hbData: {},
			fzData: {},
			qrSrc: '',
			fullscreenLoading: false,
			fzFlag: false,
			ifsFlag: true,
			iframeHeight: 0, // 初始高度设为0
			crumFlag: false,
			ljList: [],
			qrCodeImage: '',
			onlineUrl: '',
			onlineUrlOutside: '',
			previewFileOutside: {},
			previewUrls: [],
			urls: [],
			files: [],
			attId: '',
			loading: false,
			downloadDialogVisible: false,
			checkedFiles: [],
			checkAll: false,
			isIndeterminate: true,
			previewDialogVisible: false,
			previewTip: '',
			fileGroup: [],
			wjArr: ['mp3', 'wav', 'mov', 'mp4', 'jpg', 'png', 'gif'],
			
		};
	},
	computed: {
		previewFile: {
			get: function () {
				let obj = {};
				if (this.attId) {
					for (var i = 0; i < this.fileGroup.length; i++) {
						for (var j = 0; j < this.fileGroup[i].group.length; j++) {
							if (this.attId == this.fileGroup[i].group[j].attId) {
								obj = this.fileGroup[i].group[j];
							}
						}
					}
				}
				return obj;
			},
			set: function (v) {
				for (var i = 0; i < this.fileGroup.length; i++) {
					for (var j = 0; j < this.fileGroup[i].group.length; j++) {
						if (this.attId == this.fileGroup[i].group[j].attId) {
							console.log('previewFile.set.2');
							Object.assign(this.fileGroup[i].group[j], v);
						}
					}
				}
				this.$forceUpdate();
			}
		},
		previewOutFile: {
			get: function () {
				let obj = {};
				for (var i = 0; i < this.fileGroup.length; i++) {
					if (obj.previewUrl) {
						break;
					}
					for (var j = 0; j < this.fileGroup[i].group.length; j++) {
						if (this.fileGroup[i].group[j].isPreview && this.fileGroup[i].group[j].previewUrl) {
							obj = this.fileGroup[i].group[j];
							break;
						}
					}
				}
				return obj;
			},
			// 深度监听依赖变化
			cache: false
		},
		// previewOutFile() {

		// },
		filesNum() {
			let num = 0;
			if (this.fileGroup.length) {
				num = this.fileGroup.length
				// this.fileGroup.forEach((v) => {
				// 	num += v.group.length;
				// });
			}
			return num;
		}
	},
	components: {
		userHeader,
		myAudio,
		myVideo,
		crumbs,
		foot,
		fuHeader
	},
	methods: {
		hdBtn() {
			let item = '';
			this.ljList.pop();
			item = this.ljList[this.ljList.length - 1];
			if (!item) {
				this.$router.back();
				return;
			}
			if (this.documentResourceId) {
				this.documentResourceId = item.documentResourceId;
			} else if (this.toolResourceId) {
				this.toolResourceId = item.toolResourceId;
			} else if (this.mutualAidResourceId) {
				this.mutualAidResourceId = item.mutualAidResourceId;
			}
			this.$set(this.a, this.a.length - 1, item.title);
			this.init();
		},
		adjustIframeHeight() {
			this.$nextTick(() => {
				setTimeout(() => {
					const iframes = this.$refs.frame;
					// // 获取 iframe 内部文档对象
					console.log(iframes.contentWindow.document, 'esrror');
					const doc = iframes.contentDocument || iframes.contentWindow?.document;
					console.log(doc.body.scrollHeight, doc.documentElement.scrollHeight, 22222222222);
					let targetDiv = doc.documentElement.getElementsByClassName('docx-wrapper')[0];
					// 计算实际内容高度
					// const height = Math.max(
					//     doc.body.scrollHeight,
					//     doc.documentElement.scrollHeight
					// )
					// 更新高度
					this.iframeHeight = targetDiv.offsetHeight + 80;
				}, 900);
			});
		},
		openDownloadDialog() {
			this.downloadDialogVisible = true;
		},
		closeDownloadDialog() {
			this.downloadDialogVisible = false;
		},
		handleCheckAllChange(val) {
			this.checkedFiles = val ? this.fileGroup.map((v) => v.attId) : [];
			this.isIndeterminate = false;
		},
		handleCheckedFilesChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.fileGroup.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.fileGroup.length;
		},
		onDownloadPreviewAll() {
			this.xzBtn();
		},
		async xzBtn() {
			
			// if (!this.checkedFiles.length) {
			// 	this.$message({
			// 		message: '请勾选需要下载的文档',
			// 		type: 'warning'
			// 	});
			// 	return;
			// }
			this.closeDownloadDialog();
			if (this.hbData.resourceFileId || this.hbData.videoResourceFileId || this.hbData.audioResourceFileId) {
				if (this.hbData.limitsAuthority == 1) {
					if (JSON.parse(localStorage.getItem('useInfo')).authority == 0) {
						this.$message({
							message: '您现在是非会员用户，暂不能下载会员资源喔~',
							type: 'warning'
						});
						return;
					}
				}
				let id = '';
				let type = '';
				if (this.documentResourceId) {
					id = this.documentResourceId;
					type = 1;
				}
				if (this.toolResourceId) {
					id = this.toolResourceId;
					type = 3;
				}
				if (this.mutualAidResourceId) {
					id = this.mutualAidResourceId;
					type = 2;
				}
				if (this.hbData.videoResourceFileId || this.hbData.audioResourceFileId) {
					console.log('xzBtn-1');
					let files = [];
					if (this.hbData.videoResourceFileId) {
						await this.$http
							.get('api/app/common/getUrl', {
								params: {
									fileId: this.hbData.videoResourceFileId,
									id,
									type,
									downloadFlag: true,
									clientType: 1
								}
							})
							.then((res) => {
								if (res.code == 200) {
									files.push({
										name: res.fileName,
										url: res.msg
									});
								}
							});
					}
					if (this.hbData.audioResourceFileId) {
						await this.$http
							.get('api/app/common/getUrl', {
								params: {
									fileId: this.hbData.audioResourceFileId,
									downloadFlag: true,
									clientType: 1
								}
							})
							.then((red) => {
								if (red.code == 200) {
									files.push({
										name: red.fileName,
										url: red.msg
									});
								}
							});
					}
					await this.$http
						.get('api/app/common/getUrl', {
							params: {
								fileId: this.hbData.resourceFileId,
								downloadFlag: true,
								clientType: 1
							}
						})
						.then((red) => {
							if (red.code == 200) {
								files.push({
									name: red.fileName,
									url: red.msg
								});
							}
						});
					batchDownload(this.hbData.title, files);
				} else {
					console.log('xzBtn-2');
					// if (this.hbData.resourceFileId.includes(',')) {
					let arr = this.fileGroup.map((v) => v.attId)
					// let arr = this.checkedFiles;
					// let arr = this.hbData.resourceFileId.split(',');
					// 给数组循环赋值
					this.fullscreenLoading = true;
					let stop = false
					let newArr = arr.map(async (is, index) => {
						let res = await this.$http.get('api/app/common/getUrl', {
							params: {
								fileId: is,
								id: index == 0 ? id : '',
								type: index == 0 ? type : '',
								downloadFlag: true,
								clientType: 1
							}
						}); // 年龄赋值等待
						if (res.code != 200) {
							stop = true
						}
						return {
							name: res.fileName,
							url: res.msg
						};
					});
					// Promise接收一个数组
					let newArrs = await Promise.all(newArr);
					// 执行完毕，再往下走
					this.fullscreenLoading = false;
					if (stop) {
						return
					}
					console.log('最终加工好的数组结果：', newArrs);
					// batchDownloadNest(this.hbData.title, FILE_URLS);
					batchDownload(this.hbData.title, newArrs);
					// } else {
					// 	this.$xzFn(
					// 		{
					// 			fileId: this.hbData.resourceFileId,
					// 			id,
					// 			clientType: 1,
					// 			type: type
					// 		},
					// 		(res) => {}
					// 	);
					// }
				}
			} else {
				this.$message({
					message: '暂无附件哦~',
					type: 'warning'
				});
			}
		},
		loadFromUrl() {
			// 要预览的文件地址
			const url = this.fzData.msg;
			// 查看器的源，当前示例为本源
			const viewerOrigin = 'https://app.ydbooks.com/fileView';
			// const viewerOrigin = 'https://api.ydbooks.com/fileView';
			// const viewerOrigin = 'http://192.168.3.72:8521/fileView';
			this.ifsFlag = true;
			// 拼接iframe请求url
			this.qrSrc = `${viewerOrigin}?name=${encodeURIComponent(this.fzData.fileName)}&from=${encodeURIComponent(location.origin)}&url=${encodeURIComponent(url)}`;
			console.log('this.qrSrc: ', this.qrSrc);
			// this.describeDocProcessBuckets()
			// this.createDocProcessJobs()
			// this.getDocPreview()
			// this.getDocHtmlUrl()

			this.$nextTick(() => {
				const frame = this.$refs.frame;
				frame.onload = () => {
					axios({
						url,
						method: 'get',
						responseType: 'blob'
					}).then((data) => {
						if (!data) {
							console.error('文件下载失败');
						}
						console.log(data, 222);
						frame.contentWindow?.postMessage(data.data, viewerOrigin);
						// this.adjustIframeHeight()
					});
				};
			});
		},
		ewmaFn() {
			let url = '';
			if (this.type == 5 && this.yzType == '') {
				// 共享互助
				url = `pages/search/resources/file/tool-detail?id=${this.mutualAidResourceId}&type=1`;
			}
			if (this.type == 5 && this.yzType == 1) {
				// 1 同步课件 2 最新试卷 3 优质课件 4 荐阅外刊 5 双语节目 6 英语小说 7 优质课 8 双语新闻 9 每日一听 10共享互助
				if (this.classType == 2) {
					url = `pages/search/resources/file/resource-detail?id=${this.documentResourceId}&type=1`;
				}
				if (this.classType == 1) {
					url = `pages/search/resources/file/resource-detail?id=${this.documentResourceId}&type=2`;
				}
				if (this.classType == 3) {
					url = `pages/search/resources/file/resource-detail?id=${this.documentResourceId}&type=3`;
				}
				if (this.classType == 5) {
					url = `pages/search/resources/file/resource-detail?id=${this.documentResourceId}&type=4`;
				}
				if (this.classType == 6) {
					url = `pages/search/resources/file/resource-detail?id=${this.documentResourceId}&type=5`;
				}
				if (this.classType == 4) {
					url = `pages/search/resources/file/resource-detail?id=${this.documentResourceId}&type=6`;
				}
				if (this.classType == 7) {
					url = `pages/search/resources/file/resource-detail?id=${this.documentResourceId}&type=7`;
				}
				if (this.classType == 11) {
					url = `pages/search/resources/file/resource-detail?id=${this.documentResourceId}&type=8`;
				}
				// 文件
			}
			if (this.type == 6) {
				// 常用工具
				url = `pages/search/resources/file/tool-detail?id=${this.toolResourceId}&type=2`;
			}
			this.$http
				.get('api/app/common/getMiniProgramsCodes', {
					params: {
						url,
						clientType: '1'
					},
					responseType: 'blob'
				})
				.then((res) => {
					if (res) {
						const blob = new Blob([res], { type: 'image/png' });
						this.qrCodeImage = URL.createObjectURL(blob);
					}
				});
		},
		tabFn(item) {
			console.log(item.limitsAuthority, this.a, 'item');
			if (item.limitsAuthority == 1) {
				if (JSON.parse(localStorage.getItem('useInfo')).authority == 0) {
					this.$message({
						message: '您无权限浏览本页面，请点击需求申请联系辅教员~',
						type: 'warning'
					});
					return;
				}
			}
			this.ljList.push(item);
			if (this.documentResourceId) {
				this.documentResourceId = item.documentResourceId;
			} else if (this.toolResourceId) {
				this.toolResourceId = item.toolResourceId;
			} else if (this.mutualAidResourceId) {
				this.mutualAidResourceId = item.mutualAidResourceId;
			}
			this.$set(this.a, this.a.length - 1, item.title);
			this.hbList = [];
			this.init();
		},
		scFn(item) {
			let type = '';
			let assetsId = '';
			if (this.documentResourceId) {
				type = '2';
				assetsId = item.documentResourceId;
			} else if (this.toolResourceId) {
				type = '4';
				assetsId = item.toolResourceId;
			} else if (this.mutualAidResourceId) {
				type = '3';
				assetsId = item.mutualAidResourceId;
			}
			this.$scFn(
				{
					type,
					assetsId
				},
				item.isCollect,
				this.init,
				{
					type: 'cq'
				}
			);
		},
		changeGroupShow(group) {
			group.show = !group.show;
			this.$forceUpdate();
		},
		openPreviewDialog() {
			this.previewDialogVisible = true;
		},
		closePreviewDialog() {
			this.previewDialogVisible = false;
		},
		getPreview() {
			console.log('getPreview.1');
			if (this.previewFile.previewUrl) {
				return;
			}
			this.previewUrls = [];
			this.loading = true;
			if (this.wjArr.includes(this.previewFile.attType)) {
				console.log('getPreview.2');
				console.log('getPreview.2.else');
				this.$http
					.get(`api/app/common/getUrl`, {
						params: {
							fileId: this.attId,
							token: localStorage.getItem('token')
						}
					})
					.then((res) => {
						if (res.code == 200) {
							console.log('getPreview.3');
							// this.previewFile.previewUrl = res.msg;
							this.previewFile = {
								previewUrl: res.msg
							};
						}
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				this.$http
					.get(`api/app/sysAttachmentDocPreview/${this.attId}`)
					.then((res) => {
						const pagesPercentage = res.data.pagesPercentage;
						this.previewUrls = res.data.previewUrls;
						this.previewFile = { pagesPercentage };
						if (this.previewUrls.length) {
							var config = {
								// 需要替换成您自己的存储桶信息
								Bucket: 'youyidian-1304869628' /* 存储桶，必须 */,
								Region: 'ap-nanjing' /* 存储桶所在地域，必须字段 */
							};
							cos.getObjectUrl(
								{
									Bucket: config.Bucket,
									Region: config.Region,
									// Key: 'upload/doc/2025/07-1752024029244-2019新人教版必修一B1U1TEENAGELIFEProject共16张PPT.pptx',
									Key: res.data.pdfUrl,
									Query: {
										'ci-process': 'doc-preview' /* 必须，数据万象处理能力，文档预览固定为 doc-preview */,
										dstType: 'html'
									}
								},
								(err, data) => {
									if (err) {
										console.log(err);
									} else {
										var url = data.Url;
										console.log('url', url);
										// this.previewFile.previewUrl = url;
										this.previewFile = {
											previewUrl: url,
											pagesPercentage
										};
									}
								}
							);
						} else {
							// this.previewFile.previewUrl = 'fail';
							this.previewFile = {
								previewUrl: 'fail'
							};
						}
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},
		changePreview(item, index) {
			console.log('changePreview.1');
			this.attId = item.attId;
			console.log('changePreview.2');
			this.getPreview();
			console.log('changePreview.3');
		},
		getfileGroup() {
			this.onlineUrlOutside = '';
			this.hbData.fileGroup = JSON.parse(this.hbData.fileGroup);
			function swapElements(arr, index1, index2) {
			  // 检查索引是否有效
			  if (index1 < 0 || index1 >= arr.length || index2 < 0 || index2 >= arr.length) {
			    throw new Error('索引超出数组范围');
			  }
			  
			  // 使用临时变量交换
			  const temp = arr[index1];
			  arr[index1] = arr[index2];
			  arr[index2] = temp;
			  
			  return arr;
			}
			// this.hbData.fileGroup = swapElements(this.hbData.fileGroup, 0, 3)

			this.hbData.fileGroup.forEach((v) => {
				if (v.type == 1) {
					v.group = [{ ...v }];
					v.show = true;
				} else {
					v.show = false;
				}
			});
			this.fileGroup = this.hbData.fileGroup;
			console.log('this.fileGroup: ', this.fileGroup);
			let attId = '';
			for (var i = 0; i < this.fileGroup.length; i++) {
				for (var j = 0; j < this.fileGroup[i].group.length; j++) {
					this.fileGroup[i].group[j].previewUrl = '';
					if (this.fileGroup[i].group[j].isPreview || this.wjArr.includes(this.fileGroup[i].group[j].attType)) {
						this.fileGroup[i].group[j].isPreview = true;
						if (!attId) {
							attId = this.fileGroup[i].group[j].attId;
						}
					}
				}
			}
			if (attId) {
				this.attId = attId;
				this.getPreview();
			} else {
				this.previewTip = '没有可供预览的文件';
			}
		},
		init(data) {
			this.fullscreenLoading = true;
			setTimeout(() => {
				let num = this.$refs['meiWecL5'].offsetHeight;
				console.log(num, 8889);
				let nlnum = 93;
				if (this.type == 6) {
					num = num - 281;
				}
				let nums = Math.floor(num / nlnum);
				if (this.documentResourceId) {
					this.$http
						.get(`api/app/yydDocumentResource/recommend/${this.documentResourceId}`, {
							params: {
								pageNum: 1,
								pageSize: nums < 3 ? 3 : nums
							}
						})
						.then((res) => {
							this.fullscreenLoading = false;
							if (res.code == 200) {
								this.hbList = res.rows || [];
							}
						});
					this.$http.get(`api/app/yydDocumentResource/${this.documentResourceId}`).then((res) => {
						this.fullscreenLoading = false;
						if (res.code == 200) {
							this.hbData = res.data;
							this.getfileGroup();
						}
					});
				} else if (this.toolResourceId) {
					this.$http
						.get(`api/app/yydToolResource/recommend/${this.toolResourceId}`, {
							params: {
								pageNum: 1,
								pageSize: nums < 3 ? 3 : nums
							}
						})
						.then((res) => {
							this.fullscreenLoading = false;
							if (res.code == 200) {
								console.log(res, 8888);
								this.hbList = res.rows || [];
							}
						});
					this.$http.get(`api/app/yydToolResource/${this.toolResourceId}`).then((res) => {
						this.fullscreenLoading = false;
						if (res.code == 200) {
							console.log(res, 8888);
							this.hbData = res.data;
							this.getfileGroup();
						}
					});
				} else if (this.mutualAidResourceId) {
					if (this.classType != 99) {
						this.$http
							.get(`api/app/yydMutualAidResource/recommend`, {
								params: {
									pageNum: 1,
									pageSize: nums < 3 ? 3 : nums
								}
							})
							.then((res) => {
								if (res.code == 200) {
									this.hbList = res.rows || [];
								}
							});
					}
					this.$http.get(`api/app/yydMutualAidResource/${this.mutualAidResourceId}`).then((res) => {
						if (res.code == 200) {
							console.log(res, 8888);
							this.fullscreenLoading = false;
							this.hbData = res.data;
							this.getfileGroup();
						}
					});
				}
			}, 1300);
		}
	},
	mounted() {
		const { type, txt, flags, yzType, conTxt, tabFtxt, documentResourceId, toolResourceId, mutualAidResourceId, classType, crumFlag } = this.$route.query;
		if (tabFtxt) {
			this.a = typeof tabFtxt == 'string' ? [tabFtxt] : [...tabFtxt];
		}
		if (classType) {
			this.classType = classType;
		}
		this.documentResourceId = documentResourceId;
		this.toolResourceId = toolResourceId;
		this.mutualAidResourceId = mutualAidResourceId;
		this.conTxt = conTxt || '';
		this.type = type || 5;
		this.yzType = yzType;
		this.txt = txt || '';
		this.flags = flags || '';
		if (this.txt?.includes('~')) {
			this.a.push(...this.txt?.split('~'));
		} else {
			this.a.push(this.txt);
		}
		if (documentResourceId) {
			this.ljList.push({
				documentResourceId,
				title: txt
			});
		} else if (toolResourceId) {
			this.ljList.push({
				toolResourceId,
				title: txt
			});
		} else if (mutualAidResourceId) {
			this.ljList.push({
				mutualAidResourceId,
				title: txt
			});
		}
		this.ewmaFn();
		this.init();
		if (crumFlag) {
			this.crumFlag = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.download-dialog {
	.files {
		.file {
			margin: 10px 0;
		}
	}
}
</style>
<style lang="scss" scoped>
.preview-dialog {
	display: flex;
	height: 70vh;
	.preview-section {
		width: 75%;
		height: 100%;
		display: flex;
		flex-direction: column;
		overflow-y: auto;
		.ausBox {
			height: 66px;
		}
		.iframe {
			width: 100%;
			height: 100%;
		}
		.doc-preview-expand-bar {
			flex-shrink: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 10px 0 14px;
			background: #fff;
			.doc-preview-expand-btn {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				padding: 0;
				border: none;
				background: transparent;
				cursor: pointer;
				white-space: nowrap;
				&__status {
					color: #666;
					font-size: 13px;
					line-height: 1.4;
				}
				&__action {
					color: #00b578;
					font-size: 13px;
					line-height: 1.4;
				}
				&__arrow {
					display: inline-block;
					width: 6px;
					height: 6px;
					margin-left: 4px;
					margin-top: -2px;
					border-right: 1.5px solid #00b578;
					border-bottom: 1.5px solid #00b578;
					transform: rotate(45deg);
					font-style: normal;
					box-sizing: border-box;
				}
				&:hover .doc-preview-expand-btn__action,
				&:hover .doc-preview-expand-btn__arrow {
					opacity: 0.85;
				}
			}
		}
	}
	.right-section {
		flex: 1;
		margin-left: 20px;
		height: 100%;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
		.group {
			display: flex;
			flex-direction: column;
			.group-title {
				display: flex;
				align-items: center;
				padding: 10px 0;
				cursor: pointer;
				&.isShow {
					.arrow {
						transform: rotate(90deg);
					}
				}
				.arrow {
					width: 15px;
					height: 15px;
					margin-right: 5px;
				}
			}
			.file {
				display: flex;
				align-items: center;
				margin-bottom: 20px;
				cursor: pointer;
				&.active {
					.title {
						color: rgb(29, 123, 58);
					}
				}
				&.isLeaf {
					padding-left: 20px;
				}
				.icon {
					flex-shrink: 0;
				}
				.title {
					padding: 0 10px;
				}
			}
		}
	}
}
</style>
<style lang="scss" scoped>
.meiWecBox {
	width: 1200px;
	margin: 0 auto 10px;
	display: flex;
	position: relative;
	.gudBtns {
		position: absolute;
		top: 0;
		left: -65px;
		width: 58px;
		.gudBtnItem {
			width: 58px;
			height: 58px;
			margin-bottom: 4px;
			background: #fff;
			border-radius: 4px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			color: #8f9190;
			font-size: 12px;
			position: relative;
			cursor: pointer;
			img {
				margin-bottom: 3px;
			}
			.img2 {
				display: none;
			}
			.erwB {
				position: absolute;
				top: 0;
				left: 65px;
				padding: 9px 12px 0;
				z-index: 99999;
				background: #fff;
				border-radius: 15px;
				display: none;
				box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.16);
				img {
					width: 145px;
					height: 145px;
					margin: 0;
					vertical-align: bottom;
				}
				p {
					height: 30px;
					line-height: 30px;
					font-size: 12px;
					color: #000000;
					text-align: center;
				}
			}
		}
		.gudBtnItem1 {
			&:hover {
				color: #1d7b3a;
				.img1 {
					display: none;
				}
				.img2 {
					display: block;
				}
				.erwB {
					display: block;
				}
			}
		}
		.activeBtn {
			color: #1d7b3a;
		}
	}
	.meiWecL {
		flex: 1;
		margin-right: 10px;
		background: #fff;
		border-radius: 6px;
		padding: 34px 38px 50px;
		box-sizing: border-box;
		min-height: calc(100vh - 437px);
		h2 {
			color: #000000;
			font-size: 18px;
			font-weight: bold;
			margin-bottom: 23px;
			text-align: center;
		}
		p {
			color: #8f9190;
			font-size: 12px;
			text-align: center;
			margin-bottom: 51px;
			span {
				margin-right: 29px;
				&:last-of-type {
					margin-right: 0;
				}
			}
		}
		.wzCont {
			font-size: 14px;
			color: #000000;
			line-height: 1.5;
			text-indent: 2em;
		}
	}
	.meiWecL2 {
		padding: 16px 19px 48px;
		position: relative;
		.meiWec2 {
			margin: 34px 0 0;
			p {
				color: #000000;
				font-size: 14px;
				text-align: left;
				text-indent: 2em;
				line-height: 2;
				margin-bottom: 24px;
			}
			.meiWec2fot {
				display: flex;
				span {
					color: #8f9190;
					font-size: 12px;
					margin-right: 29px;
				}
			}
			.meiWec2Btn {
				width: 84px;
				height: 36px;
				background: #1d7b3a;
				position: absolute;
				bottom: 19px;
				border-radius: 7px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				font-size: 14px;
				color: #ffffff;
			}
		}
	}
	.meiWecL5 {
		display: flex;
		flex-direction: column;
		padding: 0;
		background: none;
		border-radius: 0;
		.meiWecL5-content {
			flex: 1;
			padding: 0 21px 20px;
			background: #fff;
			border-radius: 6px;
			.meiWecL5P {
				font-size: 14px;
				color: #000000;
				line-height: 2;
				margin-bottom: 18px;
			}
			.meiWecL5T {
				height: 64px;
				display: flex;
				align-items: center;
				color: #8f9190;
				font-size: 12px;
				span {
					margin-right: 29px;
				}
			}
			.meiWecL5B {
				border-radius: 13px;
			}
			.meiWecL5B1 {
				display: flex;
				align-items: center;
				justify-content: center;
				background: #f3f4f7;
				border-radius: 13px;
				color: #6b6e75;
				text-align: center;
			}
			.previewBox {
				width: 100%;
				display: flex;
				flex-direction: column;
				.files-num {
					display: flex;
					align-items: center;
					font-size: 14px;
					color: #ababab;
					cursor: pointer;
					.file {
						width: 20px;
						height: 20px;
						margin-right: 5px;
					}
					.arrow {
						widows: 8px;
						height: 12px;
						margin-left: 5px;
						margin-bottom: -1px;
					}
				}
				.previewTip {
					margin-top: 20px;
					font-size: 14px;
				}
				.previewUrls {
					width: 100%;
					display: flex;
					flex-direction: column;
					margin-top: 20px;
					.preview-section {
						width: 100%;
						height: 100%;
						display: flex;
						flex-direction: column;
						overflow-y: auto;
						.ausBox {
							height: 66px;
						}
						.iframe {
							width: 100%;
							// height: 100%;
						}
						.doc-preview-expand-bar {
							flex-shrink: 0;
							display: flex;
							align-items: center;
							justify-content: center;
							padding: 10px 0 14px;
							background: #fff;
							.doc-preview-expand-btn {
								display: inline-flex;
								align-items: center;
								justify-content: center;
								padding: 0;
								border: none;
								background: transparent;
								cursor: pointer;
								white-space: nowrap;
								&__status {
									color: #666;
									font-size: 13px;
									line-height: 1.4;
								}
								&__action {
									color: #00b578;
									font-size: 13px;
									line-height: 1.4;
								}
								&__arrow {
									display: inline-block;
									width: 6px;
									height: 6px;
									margin-left: 4px;
									margin-top: -2px;
									border-right: 1.5px solid #00b578;
									border-bottom: 1.5px solid #00b578;
									transform: rotate(45deg);
									font-style: normal;
									box-sizing: border-box;
								}
								&:hover .doc-preview-expand-btn__action,
								&:hover .doc-preview-expand-btn__arrow {
									opacity: 0.85;
								}
							}
						}
					}
				}
			}
		}
		.meiWecL5-copyright {
			margin-top: 10px;
			padding: 16px 21px;
			background: #fff;
			border-radius: 6px;
			.meiWecL5P {
				font-size: 14px;
				color: #000000;
				line-height: 2;
			}
		}
	}
	.meiWecL3 {
		padding: 18px 17px 42px 21px;
		.meiWecL3Cont {
			margin-top: 20px;
			.meiWecL3Ti {
				color: #000000;
				font-size: 18px;
				margin-bottom: 15px;
			}
			.meiWecL3P {
				font-size: 14px;
				color: #3d3d3d;
				margin-bottom: 8px;
			}
			p {
				font-size: 12px;
				line-height: 2;
				color: #8f9190;
				margin-bottom: 15px;
				text-align: left;
			}
			.meiWecL3Fot {
				display: flex;
				font-size: 12px;
				color: #8f9190;
				margin-bottom: 41px;
				span {
					margin-right: 22px;
				}
			}
		}
		.meiWecL3Nr {
			font-size: 16px;
			color: #000000;
			line-height: 3;
			text-align: center;
		}
	}

	.meiWecR {
		width: 299px;
		background: #fff;
		border-radius: 6px;
		padding: 0 10px 0 12px;
		box-sizing: border-box;
		.meiWecTit {
			height: 67px;
			display: flex;
			align-items: center;
			border-bottom: 1px solid #f8f8f8;
			font-size: 18px;
			font-weight: bold;
			img {
				width: 30px;
				height: 30px;
				margin-right: 7px;
			}
		}
		.meiWecCon {
			padding: 20px 12px;
			.meiWecItem {
				margin-bottom: 28px;
				border-bottom: 1px solid #f8f8f8;
				cursor: pointer;
				&:last-of-type {
					margin-bottom: 0;
					border-bottom: none;
				}
				.meiWecImg {
					height: 143px;
					border-radius: 12px;
					background: red;
					margin-bottom: 12px;
				}
				h3 {
					font-size: 16px;
					color: #000000;
					margin-bottom: 10px;
					font-weight: bold;
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis;
				}
				p {
					font-size: 14px;
					color: #8f9190;
					line-height: 1.5;
				}
			}
			.meiWecItem2 {
				padding: 16px 5px 18px;
				margin: 0;
				&:first-of-type {
					padding-top: 0;
				}
			}
		}
	}
	.meiWecR5 {
		background: rgb(243, 244, 247);
		padding: 0;

		.meiWecRBox {
			background: #fff;
			margin-bottom: 10px;
			padding: 0 13px 15px;
			border-radius: 6px;
			&:last-of-type {
				margin-bottom: 0;
			}
		}
		.meiWecTit5 {
			height: 60px;
			border: none;
			padding: 0 2px;
		}
		.meiWecRBoxC {
			margin-top: 5px;
			.meiWecRCItem {
				padding: 16px 3px;
				border-bottom: 1px solid #f8f8f8;
				display: flex;
				align-items: center;
				cursor: pointer;

				.imgs {
					width: 60px;
					height: 60px;
					margin-right: 7px;
					border-radius: 6px;
				}
				.meiWecRCItemR {
					flex: 1;
					p {
						overflow: hidden; /* 确保超出容器的内容被裁剪 */
						white-space: nowrap; /* 确保文本在一行内显示 */
						text-overflow: ellipsis; /* 超出部分显示省略号 */
						font-size: 14px;
						color: #000000;
						font-weight: bold;
						margin-bottom: 10px;
						width: 180px;
					}
					.meiWecRCItemRF {
						display: flex;
						justify-content: space-between;
						> div {
							display: flex;
							align-items: center;
							font-size: 12px;
							img {
								margin-right: 5px;
							}
						}
						.meiWecFjXzX {
							color: #93571c;
							display: flex;
							align-items: center;
							img {
								width: 14px;
								height: 13px;
								margin-right: 4px;
								margin-top: 2px;
							}
						}
						.meiWecFjXz {
							color: #8f9190;

							img {
								width: 12px;
								height: 13px;
							}
						}
						.meiWecFjVip {
							color: #93571c;
							img {
								width: 15px;
								height: 13px;
							}
						}
						.infoMyPut {
							background: #fff !important;
						}
					}
				}
				&:first-of-type {
					padding-top: 0;
				}
				&:last-of-type {
					border-bottom: none;
				}
			}
			.meiWecRCItem6 {
				cursor: pointer;
				img {
					width: 27px;
					height: 27px;
					margin-right: 20px;
				}
				.meiWecRCItemR {
					p {
						margin-bottom: 0 !important;
					}
				}
			}
		}
		.meiWecFjBot {
			display: flex;
			justify-content: space-between;
			font-size: 12px;
			align-items: center;
			.meiWecFjXz {
				font-size: 12px;
				color: #8f9190;
				display: flex;
				align-items: center;
				img {
					margin-right: 4px;
					width: 12px;
					height: 13px;
				}
			}
			.meiWecFjXzX {
				color: #93571c;
				display: flex;
				align-items: center;
				img {
					width: 14px;
					height: 13px;
					margin-right: 4px;
					margin-top: 2px;
				}
			}
			.meiWecFjVip {
				width: 82px;
				height: 23px;
				background: linear-gradient(90deg, #fde6d1 0%, #fdd7b3 100%);
				border-radius: 4px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 12px;
				color: #93571c;
				img {
					width: 14px;
					height: 13px;
					margin-right: 5px;
				}
			}
		}
		.meiWecFjFot {
			height: 121px;
			display: flex;
			padding: 0 15px;
			justify-content: space-between;
			align-items: center;
			.meiWecFjItem {
				text-align: center;
				cursor: pointer;
				img {
					filter: grayscale(100%);
					height: 34px;
					margin-bottom: 11px;
					vertical-align: bottom;
				}
				p {
					color: #000000;
					font-size: 14px;
				}
			}
		}
		.meiWecFj {
			padding: 14px 20px 15px 15px;
			background: #f3f4f7;
			border-radius: 7px;
			p {
				color: #000000;
				font-size: 14px;
				font-weight: bold;
				margin-bottom: 12px;
				line-height: 1.5;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}
}
.infoMyPut {
	background: linear-gradient(90deg, rgba(97, 161, 255, 0.22) 0%, rgba(0, 118, 255, 0.31) 100%) !important;
	color: #0c7bfd !important;
	i {
		font-size: 14px;
		margin-right: 2px;
		line-height: 1.2;
	}
}
</style>
